import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { CUSTLOG_INIT_LOADING, CUSTLOG_INIT_SUCCESS, CUSTLOG_INIT_FAIL } from '@/store/types'

export const custLog = {
  async custLogInit({ commit, rootState }) {
    const apiUrl = rootState.underwriting.menu.customerLog
    commit(CUSTLOG_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(CUSTLOG_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(CUSTLOG_INIT_FAIL, extractMessages(error))
    }
  }
}
